module.exports = __webpack_public_path__ + "img/model_30.b1e82198.jpg";